import { apiRequest } from '@peruselab/api-client/httpRequest';
import type { Peptide } from './Peptide';

export async function getPeptide(id: string): Promise<Peptide> {
  return apiRequest<Peptide>(`/peptides/${encodeURIComponent(id)}`, 'peptide');
}
